import { pxToRem } from '@mos-cat/ds-theme';
import { Error as ErrorIcon, File as FileIcon } from '@mos-cat/ds-icons';
import { SystemStyleObject } from '@styled-system/css';
import { Box } from '../../../../Box/Box';
import { Text } from '../../../../Text/Text';
import { WHCM, WHCMstyles } from '../../../../constants';

type FileBlockProps = {
  fileName: string;
  errorMessage: string;
};

function ErrorMessage({ children }: { children: string }) {
  return (
    <Box
      as={Text}
      role="status"
      aria-live="polite"
      display="block"
      color="errorColor"
      mb="sp-4"
    >
      {children}
    </Box>
  );
}

export function FileBlock({ fileName, errorMessage }: FileBlockProps) {
  return (
    <Box display="flex" alignItems="flex-start" mr="sp-16" aria-hidden>
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        mt="fileUploaderIconTopOffset"
        size="fileUploaderIconBlockWidth"
        styles={{ label: 'IconWrapper' }}
      >
        {errorMessage ? (
          <Text color="errorColor">
            <Box
              as={ErrorIcon}
              size="fileUploaderErrorIconSize"
              styles={
                {
                  '& path': {
                    fill: 'errorColor',
                  },
                  [WHCM]: {
                    ...WHCMstyles,
                    backgroundColor: 'ThreeDHighlight',
                    borderRadius: 'round',
                  },
                } as SystemStyleObject
              }
            />
          </Text>
        ) : (
          <Text color="fileIconColor">
            <Box as={FileIcon} size="fileUploaderFileIconSize" />
          </Text>
        )}
      </Box>
      <Box ml="sp-8" maxWidth={pxToRem(464)}>
        {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
        <Box>{fileName}</Box>
      </Box>
    </Box>
  );
}
